import AutoloadViews from './../../../../AutoloadViews';
//
import 'vue-select/dist/vue-select.css';

//
require('./../../bootstrapper');

//
window._ = require('lodash');

// Compile admin components of every block.
AutoloadViews.load('common.canvas', require.context('./../../../../../../components/common/canvas/', true, /\/admin\/(.*)\.(js|vue)$/));
AutoloadViews.load('common.canvas', require.context('./../../../../../../../../../../resources/components/common/canvas/', true, /\/admin\/(.*)\.(js|vue)$/));

//
AutoloadViews.load('common.canvas.editor.canvas.document', require.context('.', true, /\.(js|vue)$/));
